module.exports = __webpack_public_path__ + "static/media/asset01.12b842ac.jpg";